import { render, staticRenderFns } from "./AddCmp.vue?vue&type=template&id=59cd1fdc&scoped=true"
import script from "./AddCmp.vue?vue&type=script&lang=js"
export * from "./AddCmp.vue?vue&type=script&lang=js"
import style0 from "./AddCmp.vue?vue&type=style&index=0&id=59cd1fdc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cd1fdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59cd1fdc')) {
      api.createRecord('59cd1fdc', component.options)
    } else {
      api.reload('59cd1fdc', component.options)
    }
    module.hot.accept("./AddCmp.vue?vue&type=template&id=59cd1fdc&scoped=true", function () {
      api.rerender('59cd1fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimList/cmp/Add/AddCmp.vue"
export default component.exports